/** API route map: URLS.Controller.PayrollACH */
export const PayrollACH = {
      Name: 'PayrollACH/',
      GetAll: 'get-all',
      DownloadExcel: 'generate',
      DownloadBulkExcel: 'generate-bulk',
      GenerateTextFile: 'generate-text-file',
      GenerateBulkTextFile: 'generate-bulk-text-file',
      MarkAsProcessed: 'mark-as-processed',
      CheckStub: 'check-stub-employees',
      ACHEmployees: 'ACH-employees',
};
